import axios from 'axios';

//the login itself is an HttpOnly cookie the page cannot read; only its end time is kept here
const SESSION_KEY = 'sessionExpiresAt';

export const getErrorMessage = (error) =>
  error && error.data && error.data.message;

export const setSession = (expiresAt) => {
  localStorage.setItem(SESSION_KEY, expiresAt);
};

export const clearSession = () => {
  localStorage.clear();
};

export const isLoggedIn = () => {
  const expiresAt = Number(localStorage.getItem(SESSION_KEY));
  return !!expiresAt && expiresAt > Date.now();
};

export const logout = () => {
  const done = () => {
    clearSession();
    window.location.href = '/login';
  };
  axios.post('auth/logout').then(done, done);
};
